var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseSolidLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.36023V21.3602H19.5V3.36023H4.5ZM6 4.86023H18V8.61023H6V4.86023ZM6 10.1102H18V14.6102H6V10.1102ZM6 16.1102H18V19.8602H6V16.1102Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSolidLargeIcon);
export default __webpack_public_path__ + "static/media/databaseSolidLargeIcon.e1483d4fa6ff599c1d4d37b3c3345182.svg";
export { ForwardRef as ReactComponent };